/* Layouts */
// import { AuthLayout } from 'components/layouts/AuthLayout';
// import { MainLayout } from 'components/layouts/MainLayout';

import { AuthLayout } from 'components/layouts/AuthLayout';
import { MainLayout } from 'components/layouts/MainLayout';
import { Login } from 'pages/auth/Login';
import { Dashboard } from 'pages/Dashboard';
import { Profile } from 'pages/Profile';
import { Spotlight } from 'pages/Spotlight';
import { Tickets } from 'pages/Tickets';

interface Route {
  path: string;
  component?: any;
  layout?: any;
  redirectTo?: string;
  isSecured?: boolean;
  isAuthScreen?: boolean;
}

export const routes: Route[] = [
  {
    path: '/auth',
    redirectTo: '/auth/login',
  },
  // {
  //   path: '/auth/login',
  //   component: Login,
  //   layout: AuthLayout,
  //   isAuthScreen: true,
  // },
  {
    path: '/auth/login',
    component: Login,
    layout: AuthLayout,
  },
  {
    path: '/',
    component: Dashboard,
    layout: MainLayout,
    isSecured: true,
  },
  {
    path: '/spotlight',
    component: Spotlight,
    layout: MainLayout,
    isSecured: true,
  },
  {
    path: '/tickets',
    component: Tickets,
    layout: MainLayout,
    isSecured: true,
  },
  {
    path: '/profile',
    component: Profile,
    layout: MainLayout,
    isSecured: true,
  },
];

export default routes;
